import {
  Filter,
  FilterConfig,
  GenericViewConfig,
  ViewType,
  Widget,
} from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';
import { DashboardReduxWidget } from '../redux/types';
import { DashboardSmartView } from '../gzDashboardSmartViewsList/types';
import { UnifiedFilterConfig } from '../gzDashboardFilters/types';
import { getDefaultConfigForChangedWidget } from '../redux/dashboards.widgets.slice';

export class EntitiesHelper {
  public static getWidgetsForRedux(
    availableWidgets: Array<Widget>,
    views: Array<GenericViewConfig>,
    activeViewConfig: GenericViewConfig
  ): Array<DashboardReduxWidget> {
    const activeWidgetsIds = activeViewConfig.widgets.map(widget => widget.id);
    const reduxWidgets: Array<DashboardReduxWidget> = availableWidgets.map(widget => {
      const smartViewWidget = activeViewConfig.widgets.find(activeWidget => activeWidget.id === widget.id);
      if (!smartViewWidget || !activeWidgetsIds.includes(widget.id)) {
        return {
          isActive: false,
          isSelected: false,
          ...widget,
        };
      }
      return {
        isActive: true,
        isSelected: true,
        activeLayout: smartViewWidget.defaultLayout,
        ...widget,
      };
    });

    // the user might have widgets that have split into another widgets on custom views
    for (const view of views) {
      if (view.type === ViewType.DEFAULT) {
        continue;
      }

      for (const widget of view.widgets) {
        if (reduxWidgets.find(reduxWidget => reduxWidget.id === widget.id)) {
          continue;
        }

        reduxWidgets.push(getDefaultConfigForChangedWidget(widget));
      }
    }

    return reduxWidgets;
  }

  public static getSmartViewsForRedux(views: GenericViewConfig[], activeViewId: string): Array<DashboardSmartView> {
    return views.map(view => {
      return {
        ...view,
        editable: view.type === ViewType.CUSTOM,
        active: view.id === activeViewId,
      };
    });
  }

  public static getFiltersForRedux(
    filterConfigs: FilterConfig[],
    activeViewFilters: Filter[]
  ): Array<UnifiedFilterConfig> {
    return filterConfigs.map(filterConfig => {
      const smartViewFilter = activeViewFilters.find(filter => filterConfig.key === Object.keys(filter)[0]);
      if (smartViewFilter) {
        return {
          ...filterConfig,
          value: Object.values(smartViewFilter)[0],
          filterResetValue: Object.values(smartViewFilter)[0],
        };
      }
      return {
        ...filterConfig,
      };
    });
  }
}
